import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function MProductLookUp({
  handleSelectedProduct,
  formData,
  isShowModal,
}) {
  const dispatch = useDispatch();
  /*   All States
   ********************************************* */
  const [loading, setLoading] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const [productsData, setProductsData] = useState([]);
  const [sizesData, setSizesData] = useState([]);

  /*   All Functions
   ********************************************* */
  //get Data
  const getProductsData = async () => {
    try {
      setLoading(true);

      let page = 1;
      let limit = 999;
      let query = searchText || null;
      let filterBy = "styleId";

      let body = { page, limit, filterBy };

      if (query) {
        body.query = query;
      }

      const { data } = await API.post("/manufacturer/products", body, {
        headers: authHeader(),
      });
      if (data.success) {
        setProductsData(data.data);
        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  //get Data
  const getSizesData = async () => {
    try {
      setLoading(true);

      let page = 1;
      let limit = 999;
      let query = "";
      let filterBy = "all";

      let body = { page, limit, filterBy };

      if (query) {
        body.query = query;
      }

      const { data } = await API.post("manufacturer/products/sizes", body, {
        headers: authHeader(),
      });
      if (data.success) {
        setSizesData(data.data);

        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const getProductsWithNames = (product) => {
    const sizes = product.sizes || [];
    const sizesWithNames = [];
    sizes.forEach((sizeId) => {
      const sizeData = sizesData.find((s) => s.sizeId === sizeId);
      if (sizeData) {
        sizesWithNames.push(sizeData.name);
      }
    });

    // sort sizes according to sizesData?.sortId
    sizesWithNames.sort((a, b) => {
      const sizeA = sizesData.find((s) => s.name === a);
      const sizeB = sizesData.find((s) => s.name === b);
      if (sizeA && sizeB) {
        return sizeA.sortId - sizeB.sortId;
      }
      return 0; // If either size is not found, maintain original order
    });

    return sizesWithNames;
  };

  const addSizesToProducts = (product) => {
    const sizes = product.sizes || [];
    const sizesWithNames = getProductsWithNames(product);

    const _updatedProduct = {
      ...product,
      // Keep original size IDs for backend operations
      sizes: sizes,
    };

    if (sizesWithNames.length > 0) {
      _updatedProduct["sizesWithNames"] = sizesWithNames;
    }

    handleSelectedProduct(_updatedProduct);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    if (formData) {
      setSearchText(formData.productStyle || null);
    }
  }, [formData]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      getSizesData();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (searchText && isShowModal) {
        getProductsData();
      }
    }, 300);
    return () => clearTimeout(timeout);
  }, [searchText, isShowModal]);

  if (!sizesData || sizesData.length === 0) return <Spinner />;

  return (
    <div className="container-fluid p-0">
      <div className="row mb-3">
        <div className="col-12">
          <div className="input-group">
            <div className="input-group-prepend ">
              <span className="input-group-text fs-3 p-0 px-2 ">
                <i className="mdi mdi-database-search"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Style ID..."
              value={searchText || ""}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>
      </div>

      {loading ? (
        <div className="d-flex justify-content-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="product-list">
          {productsData && productsData.length > 0 ? (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="thead-light">
                  <tr>
                    <th>Product Type</th>
                    <th>Style ID</th>
                    <th>Description</th>
                    <th>Fabric</th>
                    <th>Sizes</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {productsData?.map((product) => (
                    <tr key={product.id}>
                      <td className="py-1 align-middle">
                        {product.m_product_type?.type || "N/A"}
                      </td>
                      <td className="py-1 align-middle">{product.styleId}</td>
                      <td className="py-1 align-middle">{product.desc}</td>
                      <td className="py-1 align-middle">
                        {product?.s_fabric?.name}
                      </td>
                      <td
                        className="text-truncate py-1 align-middle"
                        style={{ maxWidth: "150px" }}
                      >
                        {getProductsWithNames(product)?.join(", ") || "None"}
                      </td>
                      <td className="py-1 align-middle">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => addSizesToProducts(product)}
                        >
                          Select
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="alert alert-info text-center" role="alert">
              {searchText
                ? "No products found matching your search."
                : "Enter a Style ID to search for products."}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
